module.exports = __webpack_public_path__ + "img/logo-default.d96d74d5.svg";